/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccc_CopyrightInputs */



/**
* | output |
* | --- |
* | "© 2020-2025 Closed Caption Creator Inc. All rights reserved." |
*
* @param {Ccc_CopyrightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccc_copyright = /** @type {((inputs?: Ccc_CopyrightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccc_CopyrightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("© 2020-2025 Closed Caption Creator Inc. Tous droits réservés.")
	if (locale === "de") return /** @type {LocalizedString} */ ("© 2020-2025 Closed Caption Creator Inc. Alle Rechte vorbehalten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("© 2020-2025 Closed Caption Creator Inc. Tutti i diritti riservati.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("© 2020-2025 Closed Caption Creator Inc. Все права защищены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("© 2020-2025 Closed Caption Creator Inc. Todos los derechos reservados.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("© 2020-2025 Closed Caption Creator Inc. 保留所有权利。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("© 2020-2025 Closed Caption Creator Inc. 無断複写・転載を禁じます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("© 2020-2025 क्लोज्ड कैप्शन क्रिएटर इंक. सर्वाधिकार सुरक्षित।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("© 2020-2025 Closed Caption Creator Inc. Todos os direitos reservados.")
	return /** @type {LocalizedString} */ ("© 2020-2025 Closed Caption Creator Inc. All rights reserved.")
});